// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__xRpJJ"};